import React from 'react';
import { TeachersDay1to82026 } from '../views';


const SchoolProgrampage = () => {
  return <TeachersDay1to82026/>;
};

export default SchoolProgrampage;